import {
  Component,
  OnInit,
  HostListener,
  Inject,
  ViewChild,
  OnDestroy,
} from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { environment } from 'src/environments/environment';
import { Password, UtilService } from 'src/app/services/util.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-mobilitydashbord',
  templateUrl: './mobilitydashbord.component.html',
  styleUrls: ['./mobilitydashbord.component.scss'],
})
export class MobilitydashbordComponent implements OnInit, OnDestroy {
  constructor(
    public _ss: StoreService,
    public router: Router,
    public _fb: FormBuilder,
    public _acr: ActivatedRoute,
    private _util: UtilService
  ) {}

  public OneCommet = '';
  public TwoCommet = '';
  public ThreeCommet = '';
  public DateUpdateCommet = '';
  public TimeUpdateCommet = '';

  public form: FormGroup;
  public Teudot;
  public AllTeudotReset;
  public TeudotEach;
  public TeudotEachString;
  public Main = true;
  public Each = false;
  public Last = false;
  public Loading = true;
  public Agents;
  public TeudotTableEach;
  public LoaingConfirm = false;
  public TotalArrayChecked = 0;
  public TotalArray = 0;
  public ArrayChecked = [];

  showLogoutPopup = false;
  burgerMenu = false;
  burgerMenuNoScroll = false;
  headerAbsolute = false;
  today = new Date();
  windowWidth: number;
  movingOffset = { x: 0, y: 0 };

  destroy$: Subject<void> = new Subject();

  async ngOnInit() {
    // if (this._ss.CustomerInformation === null) {
    //   this.router.navigate(['dashbord'])
    // } else {

    this.form = this._fb.group({
      Month: ['', Validators.required],
      AgentChosen: ['', Validators.required],
      Status: ['', Validators.required],
    });

    this.windowWidth = window.innerWidth;

    window.scrollTo(0, 0);

    if (!this._ss.CustomerInformation) {
      await this.getCustInfo();
    }

    console.log(this._ss.CustomerInformation);

    this._ss
      .GetTeudotDashbord()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res: any) => {
          this.Teudot = res.recordset;

          if (this._ss.CustomerInformation?.OrderByInDashboard == '1') {
            this.Teudot = this.AllTeudotReset = res.recordset;
          } else {
            this.Teudot = this.AllTeudotReset = res.recordset.sort((a, b) => {
              if (a.TeudaDate > b.TeudaDate) {
                return -1;
              }
              if (a.TeudaDate < b.TeudaDate) {
                return 1;
              }
              return 0;
            });
          }

          for (let x = 0; x < this.Teudot.length; x++) {
            if (
              this.Teudot[x].TeudaType === 11 ||
              this.Teudot[x].TeudaType === 170 ||
              this.Teudot[x].TeudaType === 171 ||
              this.Teudot[x].TeudaType === 172
            ) {
              this.Teudot[x].TeudaTypeName = 'הזמנה';
            }
            if (this.Teudot[x].TeudaType === 74) {
              this.Teudot[x].TeudaTypeName = 'ת. החזרה';
            }
            if (this.Teudot[x].TeudaType === 7) {
              this.Teudot[x].TeudaTypeName = 'הצעת מחיר';
            }
            if (this.Teudot[x].TeudaType === 88) {
              this.Teudot[x].TeudaTypeName = 'הזמנה משריון';
            }
          }

          for (let x = 0; x < this.Teudot.length; x++) {
            this.TotalArray += this.Teudot[x].TeudaTotalSum;
          }

          this._ss
            .GetAllAgents()
            .pipe(takeUntil(this.destroy$))
            .subscribe((res) => {
              this.Agents = res;
              this.Agents = this.Agents.recordset;
              this.Loading = false;

              console.log(new Set(this.Agents.map((a) => a.AgentPhoneMobile)));
            });
        },
        (err) => {
          alert('שגיאת שרת');
        }
      );

    // }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    console.clear();
  }
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>

  async generateLoginPassword(agentid: string) {
    const pass = await this._util.getPasswordPIN(
      agentid,
      this._ss.CustomerInformation.CustNum,
      1,
      Password.generateLoginPassword,
      6
    );
    prompt('Password is:', pass);
  }

  async getCustInfo() {
    const { params } = this._acr.snapshot;
    if (params.custnum) {
      const res = await fetch(
        environment.api_url + '/mobility/custinfo/' + params.custnum
      );
      const body = await res.json();

      if (!body.recordset?.length) {
        this.router.navigate(['']);
        return;
      }

      this._ss.CustomerInformation = body.recordset[0];
    }
  }

  public StatusChoosen() {
    this.Teudot = [];

    for (let x = 0; x < this.AllTeudotReset.length; x++) {
      if (
        this.AllTeudotReset[x].Status ===
        JSON.parse(this.form.controls.Status.value)
      ) {
        this.Teudot.push(this.AllTeudotReset[x]);
      }
    }
  }
  //=====================================================================================================================================================================================================================================================================>
  public Restart() {
    this.Teudot = [];
    this.TotalArray = 0;
    this.TotalArrayChecked = 0;
    this.ArrayChecked = [];

    this.form.controls.Month.reset();
    this.form.controls.AgentChosen.reset();
    // this.Teudot = this.AllTeudotReset
    this.Main = false;
    this.Each = false;
    this.Last = false;

    window.scrollTo(0, 0);

    this._ss
      .GetTeudotDashbord()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res: any) => {
          this.Teudot = res.recordset;

          if (this._ss.CustomerInformation?.OrderByInDashboard == '1') {
            this.Teudot = this.AllTeudotReset = res.recordset;
          } else {
            this.Teudot = this.AllTeudotReset = res.recordset.sort((a, b) => {
              if (a.TeudaDate > b.TeudaDate) {
                return -1;
              }
              if (a.TeudaDate < b.TeudaDate) {
                return 1;
              }
              return 0;
            });
          }

          for (let x = 0; x < this.Teudot.length; x++) {
            if (
              this.Teudot[x].TeudaType === 11 ||
              this.Teudot[x].TeudaType === 170 ||
              this.Teudot[x].TeudaType === 171 ||
              this.Teudot[x].TeudaType === 172
            ) {
              this.Teudot[x].TeudaTypeName = 'הזמנה';
            }
            if (this.Teudot[x].TeudaType === 74) {
              this.Teudot[x].TeudaTypeName = 'ת. החזרה';
            }
            if (this.Teudot[x].TeudaType === 7) {
              this.Teudot[x].TeudaTypeName = 'הצעת מחיר';
            }
            if (this.Teudot[x].TeudaType === 88) {
              this.Teudot[x].TeudaTypeName = 'הזמנה משריון';
            }
          }

          for (let x = 0; x < this.Teudot.length; x++) {
            this.TotalArray += this.Teudot[x].TeudaTotalSum;
          }

          this._ss
            .GetAllAgents()
            .pipe(takeUntil(this.destroy$))
            .subscribe((res) => {
              this.Agents = res;
              this.Agents = this.Agents.recordset;
              this.Loading = false;
              this.Main = true;
            });
        },
        (err) => {
          alert('שגיאת שרת');
        }
      );
  }

  public seeTeuda(TeudaNum) {
    window.scrollTo(0, 0);
    this.Loading = true;
    this.Main = false;
    this._ss
      .GetTeudotFirst(TeudaNum)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.TeudotTableEach = res;
          this.TeudotTableEach = this.TeudotTableEach.recordset;
          console.log(this.TeudotEach, this.TeudotTableEach);

          setTimeout(() => {
            if (this.TeudotTableEach.length === 0) {
              this._ss
                .GetTeudotEach(TeudaNum)
                .pipe(takeUntil(this.destroy$))
                .subscribe((res) => {
                  this.TeudotEach = res;
                  this.TeudotEach = this.TeudotEach.recordset;
                  this.TeudotEachString = this.TeudotEach[0].DATAString;
                  this.TeudotEach = JSON.parse(this.TeudotEach[0].DATAString);
                  console.log(this.TeudotEach);

                  this.Each = true;
                  this.Loading = false;
                });
            } else {
              this.Last = true;
              this.Loading = false;
            }
          }, 200);
        },
        (err) => {
          alert('שגיאת שרת');
        }
      );
  }

  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>

  public PdfName;
  public DownLoadPdf = false;
  public CreatePdf() {
    let data = document.getElementById('divId');
    html2canvas(data).then((canvas) => {
      const contentDataURL = canvas.toDataURL('image/png');
      let pdf = new jspdf('l', 'cm', 'a4'); //Generates PDF in landscape mode
      // let pdf = new jspdf('p', 'cm', 'a4'); Generates PDF in portrait mode
      pdf.addImage(contentDataURL, 'PNG', 0, 0, 29.7, 21.0);
      pdf.save(this.PdfName);
    });
    this.DownLoadPdf = false;

    setTimeout(() => {
      this.Back();
    }, 1000);
  }

  public seeTeudaPdf(TeudaNum, TeudaNewNum, Client_Name) {
    this.DownLoadPdf = true;

    window.scrollTo(0, 0);
    this.Loading = true;
    this.Main = false;
    this._ss
      .GetTeudotFirst(TeudaNum)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.TeudotTableEach = res;
          this.TeudotTableEach = this.TeudotTableEach.recordset;

          console.log(this.TeudotTableEach);

          setTimeout(() => {
            if (this.TeudotTableEach.length === 0) {
              this._ss
                .GetTeudotEach(TeudaNum)
                .pipe(takeUntil(this.destroy$))
                .subscribe((res) => {
                  this.TeudotEach = res;
                  this.TeudotEach = this.TeudotEach.recordset;
                  this.TeudotEachString = this.TeudotEach[0].DATAString;
                  this.TeudotEach = JSON.parse(this.TeudotEach[0].DATAString);
                  console.log(this.TeudotEach);
                  this.Each = true;
                  this.Loading = false;
                  this.PdfName = TeudaNum;
                  setTimeout(() => {
                    this.CreatePdf();
                  }, 1000);
                });
            } else {
              this.Last = true;
              this.Loading = false;
              this.PdfName = TeudaNewNum;
              setTimeout(() => {
                this.CreatePdf();
              }, 1000);
            }
          }, 200);
        },
        (err) => {
          alert('שגיאת שרת');
        }
      );
  }

  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>

  showHideMenu(value: boolean): void {
    this.burgerMenu = value;

    if (value) {
      this.headerAbsolute = value;
      this.burgerMenuNoScroll = value;
    } else {
      setTimeout(() => {
        this.headerAbsolute = value;
        this.burgerMenuNoScroll = value;
      }, 1000);
    }
  }

  showHideLogoutPopup(value: boolean): void {
    this.showLogoutPopup = value;
  }

  onMoving({ y }): void {
    const newHeight = y - this.movingOffset.y;
    const firstTable = document.getElementById('first-table');
    const secondTable = document.getElementById('second-table');

    firstTable.style.height =
      (firstTable.offsetHeight + newHeight).toString() + 'px';
    secondTable.style.height =
      (secondTable.offsetHeight - newHeight).toString() + 'px';

    this.movingOffset.y = y;
  }

  public Back() {
    if (this.Each === true || this.Last === true) {
      this.Main = true;
      this.Each = false;
      this.Last = false;
    } else {
      history.back();
      // this.router.navigate(['dohot'])
    }
  }

  public AdminAgentLoggout(AgentID) {
    this.Loading = true;
    this._ss
      .UpdateUserLogged({ AgentID: AgentID })
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.Loading = false;
        },
        (err) => {
          alert('שגיאת שרת');
        }
      );
  }

  public OneAgent(AgentID) {
    this.Teudot = [];
    for (let x = 0; x < this.AllTeudotReset.length; x++) {
      if (this.AllTeudotReset[x].AgentID === AgentID) {
        this.Teudot.push(this.AllTeudotReset[x]);
      }
    }
  }

  public AdminAgent(AgentID) {
    this.Loading = true;
    this._ss
      .UpdateAdminOn({ AgentID: AgentID })
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.Loading = false;
        },
        (err) => {
          alert('שגיאת שרת');
        }
      );
  }

  public AdminAgentFalse(AgentID) {
    this.Loading = true;
    this._ss
      .UpdateAdminOff({ AgentID: AgentID })
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.Loading = false;
        },
        (err) => {
          alert('שגיאת שרת');
        }
      );
  }

  public SeeAll() {
    this.Teudot = this.AllTeudotReset;
  }

  public exitdashbord() {
    this.router.navigate(['']);
  }

  public closepopup() {
    this.showLogoutPopup = false;
  }

  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>

  public AdminConfirmOrder(num) {
    this.LoaingConfirm = true;
    this._ss
      .ConfirmOrderAdmin({ num: num })
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.LoaingConfirm = false;

          if (res !== 'RequestError') {
            let data = this.Teudot.find((ob) => ob.TeudaNum === num);

            if (data !== undefined) {
              this.Teudot[
                this.Teudot.indexOf(
                  this.Teudot.find((ob) => ob.TeudaNum === num)
                )
              ].Status = '0';
            }
            alert('אישור הזמנה בוצע בהצלחה');
          } else {
            alert('ישנה בעיה באישור ההזמנה');
          }
        },
        (err) => {
          alert('ישנה בעיה באישור ההזמנה');
          this.LoaingConfirm = false;
        }
      );
  }

  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>

  public MonthCondition = false;
  public ChangeMonth() {
    window.scrollTo(0, 0);
    this.MonthCondition = true;
    this.Teudot = [];
    this.TotalArray = 0;
    this.TotalArrayChecked = 0;
    this.ArrayChecked = [];

    setTimeout(() => {
      for (let x = 0; x < this.AllTeudotReset.length; x++) {
        if (
          this.AllTeudotReset[x].TeudaShowDate.toString().slice(3, 5) ===
          this.form.controls.Month.value
        ) {
          this.Teudot.push(this.AllTeudotReset[x]);
        }
      }

      for (let x = 0; x < this.Teudot.length; x++) {
        this.TotalArray += this.Teudot[x].TeudaTotalSum;
      }
    }, 100);
  }

  public ChangeAgent() {
    this.Teudot = [];
    this.TotalArray = 0;
    this.TotalArrayChecked = 0;
    this.ArrayChecked = [];

    setTimeout(() => {
      if (this.MonthCondition === true) {
        for (let x = 0; x < this.AllTeudotReset.length; x++) {
          if (
            this.AllTeudotReset[x].AgentID ===
              this.form.controls.AgentChosen.value &&
            this.AllTeudotReset[x].TeudaShowDate.toString().slice(3, 5) ===
              this.form.controls.Month.value
          ) {
            this.Teudot.push(this.AllTeudotReset[x]);
          }
        }
      } else {
        for (let x = 0; x < this.AllTeudotReset.length; x++) {
          if (
            this.AllTeudotReset[x].AgentID ===
            this.form.controls.AgentChosen.value
          ) {
            this.Teudot.push(this.AllTeudotReset[x]);
          }
        }
      }

      for (let x = 0; x < this.Teudot.length; x++) {
        this.TotalArray += this.Teudot[x].TeudaTotalSum;
      }
    }, 100);
  }

  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  public OrderChecked(TeudaNum, TeudaTotalSum) {
    let data = this.ArrayChecked.find((ob) => ob.TeudaNum === TeudaNum);

    if (data !== undefined) {
      this.ArrayChecked.splice(
        this.ArrayChecked.indexOf(
          this.ArrayChecked.find((ob) => ob.TeudaNum === TeudaNum)
        ),
        1
      );

      this.TotalArrayChecked = 0;
      for (let x = 0; x < this.ArrayChecked.length; x++) {
        this.TotalArrayChecked += this.ArrayChecked[x].TeudaTotalSum;
      }
    } else {
      this.TotalArrayChecked = 0;

      this.ArrayChecked.push({
        TeudaNum: TeudaNum,
        TeudaTotalSum: TeudaTotalSum,
      });
      for (let x = 0; x < this.ArrayChecked.length; x++) {
        this.TotalArrayChecked += this.ArrayChecked[x].TeudaTotalSum;
      }
    }
  }

  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
}
